import { render, staticRenderFns } from "./BasisTheoryForm.vue?vue&type=template&id=47b6ecc6&scoped=true&"
import script from "./BasisTheoryForm.vue?vue&type=script&lang=js&"
export * from "./BasisTheoryForm.vue?vue&type=script&lang=js&"
import style0 from "./BasisTheoryForm.vue?vue&type=style&index=0&id=47b6ecc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b6ecc6",
  null
  
)

export default component.exports